import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-accommodation-list-months',
	templateUrl: './accommodation-list-months.component.html',
	styleUrls: ['./accommodation-list-months.component.css'],
})
export class AccommodationListMonthsComponent {
	@Input() months: Array<any> = [];
	@Input() sticky = false;
	@Output() dateMove = new EventEmitter();
	selectedColumns: Array<any> = [];

	constructor() {}

	counter(end: number, start = 1) {
		const list = [];
		for (let i = start; i <= end; i++) {
			list.push(i);
		}
		return list;
	}

	onDateMove(days: number): void {
		this.dateMove.emit(days);
	}

	dayClicked(month, day: number): void {
		const divName = month.name + '-' + day;
		const index = this.selectedColumns.findIndex((obj) => obj == divName);
		if (index == -1) {
			this.selectedColumns.push(divName);
			return;
		}
		this.selectedColumns.splice(index, 1);
	}
}
